import React from 'react';
import { Box, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import TemplateCatalogGrid from '../../../../components/GenericProductConfig/components/Products/TemplateCatalogGrid';

// Templates module tab: the archetype product catalog as a full screen. Reuses
// the same catalog fetch + card grid + clone flow as the Start-from-Template
// dialog (TemplateCatalogGrid). "Use this template" clones the archetype into a
// live partner product and opens its editor.
export default function TemplatesScreen() {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <AutoAwesome sx={{ color: '#fba92c' }} />
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#173E4B' }}>
          Product Templates
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: '#6B7280', mb: 3 }}>
        Start from a curated archetype — packages, benefits and rating are pre-wired.
        Cloning creates a new live product for this partner.
      </Typography>

      <TemplateCatalogGrid />
    </Box>
  );
}
